import { Text, TextInput } from '@/components/atoms'
import { usePromotion } from '@/context/Promotion/PromotionContext'
import { PointsReward, RewardType } from '@/types/promotion'
import { ChangeEvent, FC } from 'react'
import { RewardItemProps } from './RewardItem'

export const RewardPoints: FC<RewardItemProps> = ({ promotionCondition }) => {
  const { updateCondition } = usePromotion()

  const { rewards } = promotionCondition

  const updatePoints = (value: number | string) => {
    updateCondition({
      ...promotionCondition,
      rewards: [
        {
          type: RewardType.POINTS,
          points: Number(value),
        },
      ],
    })
  }

  const handleKeyDown = e => {
    const { key } = e
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete']

    if ((key >= '0' && key <= '9') || allowedKeys.includes(key)) {
      return
    }

    e.preventDefault()
  }

  const handlePointsChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value
    const isValid = /^-?\d+$/.test(value) || value === ''
    const oldValue = (rewards?.[0] as PointsReward)?.points || ''
    const newValue = isValid ? value : oldValue
    //This is a bug in peacock TextInput, if we pass the same value to the input, it will not trigger the onChange event
    updatePoints(value)
    setTimeout(() => {
      updatePoints(newValue)
    }, 0)
  }

  const points = (rewards?.[0] as PointsReward)?.points || ''

  return (
    <>
      <TextInput
        type="text"
        onInputChange={handlePointsChange}
        placeholderText="0"
        isDark={true}
        value={!Number.isNaN(points) ? points.toString() : ''}
        handleKeyDown={handleKeyDown}
        // @ts-ignore
        style={{ maxWidth: "120px" }}
      />
      <Text>{'points.'}</Text>
    </>
  )
}
